import { numberMoney } from 'Data/format.js'
import { getRemainingAmount } from 'Data/payment-plan.js'

export function getValue(payment_plan) {
  return numberMoney(getRemainingAmount(payment_plan))
}
